import { TFunction } from 'react-i18next';
import { formatFullDate } from '../../../lib/common';

export const getEndDateTitle = (t: TFunction, language: string, short: boolean, endsAt?: string): string =>
  `${t('surveyEnd', {
    ns: 'weekPicker',
  })}: ${endsAt ? formatFullDate(endsAt, language, short) : '-'}`;
